import { envConfigs } from '../envConfigs';
import { appActions, LOG_LEVEL } from '../modules/app/reducer/app-reducer';

export const foundationsKey = 'Foundations';
export const adminToolsKey = 'AdminTools';
export const gaiaKey = 'FB';
export const luisenoKey = 'Luiseno';
export const catalystProductId = 'product.e6e353e1-7e31-4f36-a995-8bd4facddaf5';
export const webiParentProductId = 'product.5c49ea4d-767f-4672-d60f-43274498516f';
export const foundationProductId = 'product.d353e204-5952-4175-be5e-0a5630bfab6c';

const ojibweProductIds = [ 'product.b9777dba-0343-4262-a87e-b78201b737d6', 'product.01eb6268-33ca-4db5-bf2e-9d8ac4eee867' ];

const cefrLevels = ['A1', 'A2', 'BELOW_B1', 'B1', 'B2', 'ABOVE_B2', 'C1', 'C2'];
const orderedAssessmentCefrLevels = [
  'Below A1',
  'A1',
  'A2',
  'A2+',
  'Below B1',
  'BELOW_B1',
  'B1',
  'B2',
  'ABOVE_B2',
  'C1',
  'C1+',
  'C2'
];

const productConfigs = [
  {
    key: adminToolsKey,
    sirenProductId: 'product.d8aead88-fcca-4128-868e-fdc8f0bc6f33',
    uri: envConfigs.rsmUri
  },
  {
    key: foundationsKey,
    sirenProductId: 'product.d353e204-5952-4175-be5e-0a5630bfab6c',
    uri: envConfigs.totaleUri + '?access_token='
  },
  {
    key: gaiaKey,
    sirenProductId: 'product.6a1a08c9-7e8d-c5cc-58a8-96e93a35df94',
    uri: envConfigs.gaiaUri,
    levels: cefrLevels,
    minimumLevels: [
      {
        language: 'en-US',
        level: 'B1'
      }
    ],
    hideSelfAssessment: true
  },
  {
    key: luisenoKey,
    sirenProductId: 'product.e4ab719c-61f1-488f-90da-db4be079c346',
    uri: envConfigs.gaiaUri,
    hideSelfAssessment: true
  }
];

export const getOrderedAssessmentCefrLevelIndex = (cefrLevel) => {
  return orderedAssessmentCefrLevels.indexOf(cefrLevel);
};

export const getProductInfoByKey = (infoKey) => {
  return productConfigs.find((aProduct) => {
    return aProduct.key === infoKey;
  });
};

export const getProductInfoByProductId = (productId) => {
  return productConfigs.find((aProduct) => {
    return aProduct.sirenProductId === productId;
  });
};

export const hasOjibweProducts = (products) => {
  return products.some((item) =>
    ojibweProductIds.includes(item.product_id)
  );
};

// If the user has multiple Ojibwe products, keep only one and rename it to 'Ojibwe'
export const ojibweLicenseFilter = (products) => {
  const numOfOjibweProducts = products.filter((item) =>
    ojibweProductIds.includes(item.product_id)
  ).length;
  // Check if there is more than one Ojibwe product
  if (numOfOjibweProducts > 1) {
    const ojibweProductIndex = products.findIndex((item) =>
      ojibweProductIds.includes(item.product_id)
    );
    // Filter products to include only the first Ojibwe product and non-Ojibwe products
    const filteredProducts = products.map((item, index) => {
      if (index === ojibweProductIndex) {
        return {
          ...item,
          product_name: 'Ojibwe',
        };
      }
      return ojibweProductIds.includes(item.product_id) ? null : item;
    }).filter(Boolean);
    return filteredProducts;
  }
  
  return products;
};

/**
 * Validate that the requested URI is one of the product's allowed destinations.
 *
 * @param productConfig
 * @param uri Requested redirect URI
 */
const validateUriForProduct = (productConfig, uri) => {
  if (uri && productConfig.uri) {
    if (productConfig.uri && uri.indexOf(productConfig.uri) === 0) {
      return true;
    }
  }
  return false;
};

// this is a method which is preparing for other catalysts, e.g. with Fluency Builder instead of AEB/RSA
export const isCatalyst = (productId) => {
  const catalystIds = [catalystProductId];
  return catalystIds.indexOf(productId) !== -1;
};

export const isParentProduct = (productId) => {
  const parentProductIds = [catalystProductId, webiParentProductId];
  return parentProductIds.indexOf(productId) !== -1;
};

export const isCatalystAdmin = (productId) => {
  const AdminToolsId = ['product.d8aead88-fcca-4128-868e-fdc8f0bc6f33'];
  return AdminToolsId.indexOf(productId) !== -1;
};

export const launchAppWithKey = (productKey, redirectUri) => {
  if (productKey) {
    const productInfo = getProductInfoByKey(productKey);
    if (productInfo) {
      // If we have a requested URI, verify it; else load the first (default) client URI.
      if (!redirectUri) {
        redirectUri = productInfo.uri;
      }
      // On success, validate the client and redirect if it's all kosher.
      if (validateUriForProduct(productInfo, redirectUri)) {
        window.location.assign(redirectUri);
        return true;
      }
      appActions.logEvent({ level: LOG_LEVEL.ERROR, message: 'Cannot launch product; invalid redirect URI provided.' });
    } else {
      appActions.logEvent({
        level: LOG_LEVEL.ERROR,
        message: 'Cannot launch product; invalid productKey "' + productKey + '" provided.'
      });
    }
  } else {
    appActions.logEvent({ level: LOG_LEVEL.ERROR, message: 'Cannot launch product; no productKey provided.' });
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/helpers/productConfigHelper.js